import { Injectable } from '@angular/core';
import { BsDatepickerConfig } from './pmd-datepicker.config';

@Injectable()
export class PmdDaterangepickerConfig extends BsDatepickerConfig {
  // DatepickerRenderOptions
  displayMonths = 2;
}
